# Generated by https://pagedraw.io/pages/1470
React = require 'react'
createReactClass = require 'create-react-class'


module.exports = Frameworkpickerradiobutton = createReactClass {
    displayName: 'Frameworkpickerradiobutton'
    render: ->
        React.createElement("div", {"className": "frameworkpickerradiobutton"},
          React.createElement("style", {"dangerouslySetInnerHTML": (__html: """
              @import url('https://fonts.googleapis.com/css?family=Lato:');
              
              .frameworkpickerradiobutton {
                  display: flex;
                  flex-grow: 1;
              }
              
              .frameworkpickerradiobutton-0-0 {
                  display: flex;
                  flex-grow: 1;
              }
              
              .frameworkpickerradiobutton-default-3 {
                  display: flex;
                  flex-direction: column;
                  flex-grow: 1;
              }
              
              .frameworkpickerradiobutton-0-0-0-0-0 {
                  display: flex;
                  flex-shrink: 0;
                  flex-grow: 1;
                  flex-basis: 0px;
                  min-height: fit-content;
              }
              
              .frameworkpickerradiobutton-rectangle-8 {
                  display: flex;
                  flex-direction: column;
                  flex-grow: 1;
                  flex-basis: 0px;
                  min-height: fit-content;
                  justify-content: center;
                  border-radius: 7px;
                  background: rgb(245, 245, 245);
                  border: 3px solid rgb(214, 214, 214);
              }
              
              .frameworkpickerradiobutton-0-0-0-0-0-0-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .frameworkpickerradiobutton-0-0-0-0-0-0-0-0 {
                  height: 0px;
                  flex-grow: 0.037815126050420166;
                  flex-basis: 0px;
              }
              
              .frameworkpickerradiobutton-rectangle_2 {
                  display: flex;
                  flex-direction: column;
                  flex-grow: 0.9243697478991597;
                  flex-basis: 0px;
                  min-height: fit-content;
              }
              
              .frameworkpickerradiobutton-0-0-0-0-0-0-0-1-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .frameworkpickerradiobutton-image_6 {
                  width: 61px;
                  height: 61px;
                  flex-shrink: 0;
                  background-size: contain;
                  background-position: center;
                  background-repeat: no-repeat;
              }
              
              .frameworkpickerradiobutton-0-0-0-0-0-0-0-1-0-1 {
                  display: flex;
                  flex-direction: column;
                  flex-grow: 1;
                  flex-basis: 0px;
                  min-height: fit-content;
                  margin-left: 10px;
                  padding-top: 1px;
              }
              
              .frameworkpickerradiobutton-0-0-0-0-0-0-0-1-0-1-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .frameworkpickerradiobutton-text_5 {
                  flex-grow: 1;
                  flex-basis: 0px;
                  font-family: "Lato", sans-serif;
                  color: rgb(26, 23, 116);
                  font-size: 18px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: bold;
                  font-style: normal;
                  text-decoration: none;
                  text-align: left;
                  word-wrap: break-word;
              }
              
              .frameworkpickerradiobutton-0-0-0-0-0-0-0-1-0-1-1 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 4px;
              }
              
              .frameworkpickerradiobutton-text_4 {
                  flex-grow: 1;
                  flex-basis: 0px;
                  font-family: "Lato", sans-serif;
                  color: rgba(0, 0, 0, 0.7);
                  font-size: 14px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: normal;
                  font-style: normal;
                  text-decoration: none;
                  text-align: left;
                  word-wrap: break-word;
              }
              
              .frameworkpickerradiobutton-0-0-0-0-0-0-0-2 {
                  height: 0px;
                  flex-grow: 0.037815126050420166;
                  flex-basis: 0px;
              }
              
              .frameworkpickerradiobutton-_hover-9 {
                  display: flex;
                  flex-direction: column;
                  flex-grow: 1;
              }
              
              .frameworkpickerradiobutton-0-0-1-0 {
                  display: flex;
                  flex-shrink: 0;
                  flex-grow: 1;
                  flex-basis: 0px;
                  min-height: fit-content;
              }
              
              .frameworkpickerradiobutton-rectangle-1 {
                  display: flex;
                  flex-direction: column;
                  flex-grow: 1;
                  flex-basis: 0px;
                  min-height: fit-content;
                  justify-content: center;
                  border-radius: 7px;
                  background: rgb(192, 191, 210);
                  border: 3px solid rgb(214, 214, 214);
              }
              
              .frameworkpickerradiobutton-0-0-1-0-0-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .frameworkpickerradiobutton-0-0-1-0-0-0-0 {
                  height: 0px;
                  flex-grow: 0.037815126050420166;
                  flex-basis: 0px;
              }
              
              .frameworkpickerradiobutton-rectangle_2-5 {
                  display: flex;
                  flex-direction: column;
                  flex-grow: 0.9243697478991597;
                  flex-basis: 0px;
                  min-height: fit-content;
              }
              
              .frameworkpickerradiobutton-0-0-1-0-0-0-1-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .frameworkpickerradiobutton-image_6-8 {
                  width: 61px;
                  height: 61px;
                  flex-shrink: 0;
                  background-size: contain;
                  background-position: center;
                  background-repeat: no-repeat;
              }
              
              .frameworkpickerradiobutton-0-0-1-0-0-0-1-0-1 {
                  display: flex;
                  flex-direction: column;
                  flex-grow: 1;
                  flex-basis: 0px;
                  min-height: fit-content;
                  margin-left: 10px;
                  padding-top: 1px;
              }
              
              .frameworkpickerradiobutton-0-0-1-0-0-0-1-0-1-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .frameworkpickerradiobutton-text_5-2 {
                  flex-grow: 1;
                  flex-basis: 0px;
                  font-family: "Lato", sans-serif;
                  color: rgb(26, 23, 116);
                  font-size: 18px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: bold;
                  font-style: normal;
                  text-decoration: none;
                  text-align: left;
                  word-wrap: break-word;
              }
              
              .frameworkpickerradiobutton-0-0-1-0-0-0-1-0-1-1 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 4px;
              }
              
              .frameworkpickerradiobutton-text_4-3 {
                  flex-grow: 1;
                  flex-basis: 0px;
                  font-family: "Lato", sans-serif;
                  color: rgba(0, 0, 0, 0.7);
                  font-size: 14px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: normal;
                  font-style: normal;
                  text-decoration: none;
                  text-align: left;
                  word-wrap: break-word;
              }
              
              .frameworkpickerradiobutton-0-0-1-0-0-0-2 {
                  height: 0px;
                  flex-grow: 0.037815126050420166;
                  flex-basis: 0px;
              }
              
              .frameworkpickerradiobutton-selected-7 {
                  display: flex;
                  flex-direction: column;
                  flex-grow: 1;
              }
              
              .frameworkpickerradiobutton-1-0-0 {
                  display: flex;
                  flex-shrink: 0;
                  flex-grow: 1;
                  flex-basis: 0px;
                  min-height: fit-content;
              }
              
              .frameworkpickerradiobutton-rectangle-9 {
                  display: flex;
                  flex-direction: column;
                  flex-grow: 1;
                  flex-basis: 0px;
                  min-height: fit-content;
                  justify-content: center;
                  border-radius: 7px;
                  background: rgb(26, 23, 116);
                  border: 3px solid rgb(72, 71, 173);
              }
              
              .frameworkpickerradiobutton-1-0-0-0-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .frameworkpickerradiobutton-1-0-0-0-0-0 {
                  height: 0px;
                  flex-grow: 0.037815126050420166;
                  flex-basis: 0px;
              }
              
              .frameworkpickerradiobutton-rectangle_2-4 {
                  display: flex;
                  flex-direction: column;
                  flex-grow: 0.9243697478991597;
                  flex-basis: 0px;
                  min-height: fit-content;
              }
              
              .frameworkpickerradiobutton-1-0-0-0-0-1-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .frameworkpickerradiobutton-image_6-0 {
                  width: 61px;
                  height: 61px;
                  flex-shrink: 0;
                  background-size: contain;
                  background-position: center;
                  background-repeat: no-repeat;
              }
              
              .frameworkpickerradiobutton-1-0-0-0-0-1-0-1 {
                  display: flex;
                  flex-direction: column;
                  flex-grow: 1;
                  flex-basis: 0px;
                  min-height: fit-content;
                  margin-left: 10px;
                  padding-top: 1px;
              }
              
              .frameworkpickerradiobutton-1-0-0-0-0-1-0-1-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .frameworkpickerradiobutton-text_5-4 {
                  flex-grow: 1;
                  flex-basis: 0px;
                  font-family: "Lato", sans-serif;
                  color: rgb(241, 241, 241);
                  font-size: 18px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: bold;
                  font-style: normal;
                  text-decoration: none;
                  text-align: left;
                  word-wrap: break-word;
              }
              
              .frameworkpickerradiobutton-1-0-0-0-0-1-0-1-1 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 4px;
              }
              
              .frameworkpickerradiobutton-text_4-6 {
                  flex-grow: 1;
                  flex-basis: 0px;
                  font-family: "Lato", sans-serif;
                  color: rgba(224, 224, 224, 0.7);
                  font-size: 14px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: normal;
                  font-style: normal;
                  text-decoration: none;
                  text-align: left;
                  word-wrap: break-word;
              }
              
              .frameworkpickerradiobutton-1-0-0-0-0-2 {
                  height: 0px;
                  flex-grow: 0.037815126050420166;
                  flex-basis: 0px;
              }
              
              * {
                  box-sizing: border-box;
              }
              
              body {
                  margin: 0;
              }
              
              button:hover {
                  cursor: pointer;
              }
              
              a {
                  text-decoration: none;
                  color: inherit;
              }
              
              .pd-onhover-parent >.pd-onhover {
                  display: none;
              }
              
              .pd-onhover-parent:hover > * {
                  display: none;
              }
              
              .pd-onhover-parent:hover > .pd-onhover {
                  display: flex;
              }
              
              .pd-onactive-parent > .pd-onactive {
                  display: none;
              }
              
              .pd-onactive-parent:active > * {
                  display: none;
              }
              
              .pd-onactive-parent:active > .pd-onactive {
                  display: flex;
              }
              
              .pd-onactive-parent.pd-onhover-parent:active > .pd-onhover {
                  display: none;
              }
          """)}),  
          ( if ((if this.props.selected then 'selected' else 'default') == "default")
              React.createElement("div", {"className": "pd-onhover-parent frameworkpickerradiobutton-0-0"},
                  ( if (("default") == "default")
                      React.createElement("div", {"className": "frameworkpickerradiobutton-default-3"},
                          React.createElement("div", {"className": "frameworkpickerradiobutton-0-0-0-0-0"},
                              React.createElement("div", {"className": "frameworkpickerradiobutton-rectangle-8"},
                                  React.createElement("div", {"className": "frameworkpickerradiobutton-0-0-0-0-0-0-0"},
                                      React.createElement("div", {"className": "frameworkpickerradiobutton-0-0-0-0-0-0-0-0"}),  
                                      React.createElement("div", {"className": "frameworkpickerradiobutton-rectangle_2"},
                                          React.createElement("div", {"className": "frameworkpickerradiobutton-0-0-0-0-0-0-0-1-0"},
                                              React.createElement("div", {"className": "frameworkpickerradiobutton-image_6", "style": ({"backgroundImage": ("url('"+(this.props.img)+"')")})}),  
                                              React.createElement("div", {"className": "frameworkpickerradiobutton-0-0-0-0-0-0-0-1-0-1"},
                                                  React.createElement("div", {"className": "frameworkpickerradiobutton-0-0-0-0-0-0-0-1-0-1-0"},
                                                      React.createElement("div", {"className": "frameworkpickerradiobutton-text_5"},
                                                          ( this.props.name )
                                                      )
                                                  ),
                                                  React.createElement("div", {"className": "frameworkpickerradiobutton-0-0-0-0-0-0-0-1-0-1-1"},
                                                      React.createElement("div", {"className": "frameworkpickerradiobutton-text_4"},
                                                          ( this.props.desc )
                                                      )
                                                  )
                                              )
                                          )
                                      ),
                                      React.createElement("div", {"className": "frameworkpickerradiobutton-0-0-0-0-0-0-0-2"}) 
                                  )
                              )
                          )
                      )
                  ),
                  React.createElement("div", {"className": "pd-onhover frameworkpickerradiobutton-_hover-9"},
                      React.createElement("div", {"className": "frameworkpickerradiobutton-0-0-1-0"},
                          React.createElement("div", {"onMouseUp": (this.props.handleClick), "className": "frameworkpickerradiobutton-rectangle-1"},
                              React.createElement("div", {"className": "frameworkpickerradiobutton-0-0-1-0-0-0"},
                                  React.createElement("div", {"className": "frameworkpickerradiobutton-0-0-1-0-0-0-0"}),  
                                  React.createElement("div", {"className": "frameworkpickerradiobutton-rectangle_2-5"},
                                      React.createElement("div", {"className": "frameworkpickerradiobutton-0-0-1-0-0-0-1-0"},
                                          React.createElement("div", {"className": "frameworkpickerradiobutton-image_6-8", "style": ({"backgroundImage": ("url('"+(this.props.img)+"')")})}),  
                                          React.createElement("div", {"className": "frameworkpickerradiobutton-0-0-1-0-0-0-1-0-1"},
                                              React.createElement("div", {"className": "frameworkpickerradiobutton-0-0-1-0-0-0-1-0-1-0"},
                                                  React.createElement("div", {"className": "frameworkpickerradiobutton-text_5-2"},
                                                      ( this.props.name )
                                                  )
                                              ),
                                              React.createElement("div", {"className": "frameworkpickerradiobutton-0-0-1-0-0-0-1-0-1-1"},
                                                  React.createElement("div", {"className": "frameworkpickerradiobutton-text_4-3"},
                                                      ( this.props.desc )
                                                  )
                                              )
                                          )
                                      )
                                  ),
                                  React.createElement("div", {"className": "frameworkpickerradiobutton-0-0-1-0-0-0-2"}) 
                              )
                          )
                      )
                  )
              )
          ),
          ( if ((if this.props.selected then 'selected' else 'default') == "selected")
              React.createElement("div", {"className": "frameworkpickerradiobutton-selected-7"},
                  React.createElement("div", {"className": "frameworkpickerradiobutton-1-0-0"},
                      React.createElement("div", {"className": "frameworkpickerradiobutton-rectangle-9"},
                          React.createElement("div", {"className": "frameworkpickerradiobutton-1-0-0-0-0"},
                              React.createElement("div", {"className": "frameworkpickerradiobutton-1-0-0-0-0-0"}),  
                              React.createElement("div", {"className": "frameworkpickerradiobutton-rectangle_2-4"},
                                  React.createElement("div", {"className": "frameworkpickerradiobutton-1-0-0-0-0-1-0"},
                                      React.createElement("div", {"className": "frameworkpickerradiobutton-image_6-0", "style": ({"backgroundImage": ("url('"+(this.props.img)+"')")})}),  
                                      React.createElement("div", {"className": "frameworkpickerradiobutton-1-0-0-0-0-1-0-1"},
                                          React.createElement("div", {"className": "frameworkpickerradiobutton-1-0-0-0-0-1-0-1-0"},
                                              React.createElement("div", {"className": "frameworkpickerradiobutton-text_5-4"},
                                                  ( this.props.name )
                                              )
                                          ),
                                          React.createElement("div", {"className": "frameworkpickerradiobutton-1-0-0-0-0-1-0-1-1"},
                                              React.createElement("div", {"className": "frameworkpickerradiobutton-text_4-6"},
                                                  ( this.props.desc )
                                              )
                                          )
                                      )
                                  )
                              ),
                              React.createElement("div", {"className": "frameworkpickerradiobutton-1-0-0-0-0-2"}) 
                          )
                      )
                  )
              )
          )
      )
}



// WEBPACK FOOTER //
// ./node_modules/cjsx-loader!./src/pagedraw/frameworkpickerradiobutton.cjsx